<script lang="ts">
	/**
	 * A generic Link component that can handle internal and external links. If internal is selected,
	 * the given link should be the slug of the internal page and the component will prefix the correct language.
	 * If external is selected, the component will automatically add https to the link if not already present.
	 */
	type LinkType = 'internal' | 'custom' | 'category' | 'file' | 'collection' | 'product';

	import { page as p } from '$app/stores';
	$: lang = $p.params?.lang;

	/*********
	 * Props *
	 **********/
	export let type: LinkType = 'custom'; // Type of the link ('custom' or 'internal')
	export let link: string; // The link to use (typically the slug if intern, otherwise an external url)
	export let aria_label: string | undefined = undefined; // (Optional) Label for accessibility if no text is displayed in link
	export let new_tab: boolean = false;

	let http_link: string;
	$: {
		if (type === 'custom' || type === 'file') {
			if (
				!link?.startsWith('http') &&
				!link?.startsWith('mailto') &&
				!link?.startsWith('tel') &&
				link !== undefined
			) {
				http_link = 'https://' + link;
			} else {
				http_link = link;
			}
		} else {
			http_link = '/' + lang + (link?.startsWith('home') ? link.replace('home', '') : '/' + link);
		}
	}
</script>

<a href={http_link} aria-label={aria_label} target={new_tab ? '_blank' : null} on:click>
	<slot />
</a>

<style lang="scss">
	a {
		display: inline-flex;
		align-items: center;
		text-decoration: none;
	}
</style>
